module.exports = __webpack_public_path__ + "img/facilities_01.5dbaded8.jpg";